export default __webpack_public_path__ + "static/media/DSC_7478.4336f7e3.jpg";